import { MemberType } from 'api/models';
import { ResourceType } from 'api/resource-management/types';
import { EffortPlanningConfig } from 'components/organisms/effort-planning-modal/types';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
const getSources = ({ sources })=>(sources !== null && sources !== void 0 ? sources : []).filter(Boolean) // antd form.list add undefined to an array whenever we click new item, it will look like [undefined], so we need to filter it.
    .map((eachSource)=>eachSource.source);
export const getAllSources = ({ source, ...restFormValues })=>{
    return [
        source,
        ...getSources(restFormValues)
    ].filter(Boolean);
};
export const getTemplates = async (templateIds)=>{
    try {
        return await Promise.all(templateIds.map(async (value)=>TemplatesAPI.getById(value)));
    } catch (error) {
        logger.error(`Unable to get templates for ${templateIds.join(', ')}`, {
            error
        });
        return [];
    }
};
export const getFieldFiltersFromTemplates = (templates)=>{
    return {
        customFields: templates.reduce((prev, next)=>{
            var _next_templateMeta_fieldFilters, _next_templateMeta;
            if ((_next_templateMeta = next.templateMeta) === null || _next_templateMeta === void 0 ? void 0 : (_next_templateMeta_fieldFilters = _next_templateMeta.fieldFilters) === null || _next_templateMeta_fieldFilters === void 0 ? void 0 : _next_templateMeta_fieldFilters.customFields) {
                prev.push(...next.templateMeta.fieldFilters.customFields);
            }
            return prev;
        }, []),
        nativeFields: templates.reduce((prev, next)=>{
            var _next_templateMeta_fieldFilters, _next_templateMeta;
            if ((_next_templateMeta = next.templateMeta) === null || _next_templateMeta === void 0 ? void 0 : (_next_templateMeta_fieldFilters = _next_templateMeta.fieldFilters) === null || _next_templateMeta_fieldFilters === void 0 ? void 0 : _next_templateMeta_fieldFilters.nativeFields) {
                prev.push(...next.templateMeta.fieldFilters.nativeFields);
            }
            return prev;
        }, [])
    };
};
export const getTotalAllocatedMinutesForTeamInTemplate = (allocations)=>(teamId)=>allocations.filter((x)=>x.type !== ResourceType.User && x.teamId === teamId).reduce((total, x)=>total + x.minutes * x.duration, 0);
/**
 * Workaround util to get template placeholders
 */ export const getPlaceholdersFromTemplate = ({ template, rolesWithPlaceholder, teamsLookup })=>{
    const placeholderList = {};
    const activeRoleIds = rolesWithPlaceholder === null || rolesWithPlaceholder === void 0 ? void 0 : rolesWithPlaceholder.map(({ roleId })=>roleId);
    const { templateContent: { projectPhases, allocatedMembers }, effortPlanning } = template;
    const checkPhases = (phase)=>{
        const { assignees } = phase;
        if (assignees == null || assignees.length === 0) {
            return;
        }
        assignees.forEach((assignee)=>{
            var _assignee_team;
            if (((_assignee_team = assignee.team) === null || _assignee_team === void 0 ? void 0 : _assignee_team.teamId) == null || teamsLookup[assignee.team.teamId] == null) {
                return;
            }
            const { teamId } = assignee.team;
            if (!placeholderList[teamId]) {
                placeholderList[teamId] = teamsLookup[teamId];
            }
        });
    };
    const checkTask = (task)=>{
        var _assignee_teams;
        const { assignee, subTasks = [] } = task;
        assignee === null || assignee === void 0 ? void 0 : (_assignee_teams = assignee.teams) === null || _assignee_teams === void 0 ? void 0 : _assignee_teams.forEach((team)=>{
            const { teamId, roleId } = team;
            if (!roleId || roleId !== -1 && !(activeRoleIds === null || activeRoleIds === void 0 ? void 0 : activeRoleIds.includes(roleId))) {
                return;
            }
            if (!placeholderList[teamId]) {
                var _teamsLookup_teamId;
                /**
         * Picking the team object from store since team object inside template
         * may be outdated when the default placeholder name got changed
         * due to change in role name.
         */ placeholderList[teamId] = (_teamsLookup_teamId = teamsLookup[teamId]) !== null && _teamsLookup_teamId !== void 0 ? _teamsLookup_teamId : team;
            }
        });
        subTasks.forEach(checkTask);
    };
    projectPhases.forEach((phase)=>{
        const { tasks } = phase;
        tasks.forEach(checkTask);
        if (effortPlanning === EffortPlanningConfig.Phase) {
            checkPhases(phase);
        }
    });
    allocatedMembers === null || allocatedMembers === void 0 ? void 0 : allocatedMembers.teams.forEach((team)=>{
        const { teamId, roleId } = team;
        if (!roleId || roleId !== -1 && !(activeRoleIds === null || activeRoleIds === void 0 ? void 0 : activeRoleIds.includes(roleId))) {
            return;
        }
        if (!placeholderList[teamId]) {
            var _teamsLookup_teamId;
            placeholderList[teamId] = (_teamsLookup_teamId = teamsLookup[teamId]) !== null && _teamsLookup_teamId !== void 0 ? _teamsLookup_teamId : team;
        }
    });
    return placeholderList;
};
/**
 *
 * @description Returns teams for the template when creating project. Created for fixing bug where new placeholders
 * created when saving project as template didnt show up in task assignee renderer.
 */ export const getPlaceholdersFromTasks = ({ tasks, rolesWithPlaceholder, teamsLookup })=>{
    const placeholderList = {};
    const activeRoleIds = rolesWithPlaceholder === null || rolesWithPlaceholder === void 0 ? void 0 : rolesWithPlaceholder.map(({ roleId })=>roleId);
    const checkTask = (task)=>{
        var _assignee_teams;
        const { assignee } = task;
        assignee === null || assignee === void 0 ? void 0 : (_assignee_teams = assignee.teams) === null || _assignee_teams === void 0 ? void 0 : _assignee_teams.forEach((team)=>{
            const { teamId, roleId } = team;
            if (!roleId || roleId !== -1 && !(activeRoleIds === null || activeRoleIds === void 0 ? void 0 : activeRoleIds.includes(roleId))) {
                return;
            }
            if (!placeholderList[teamId]) {
                var _teamsLookup_teamId;
                /**
         * Picking the team object from store since team object inside template
         * may be outdated when the default placeholder name got changed
         * due to change in role name.
         */ placeholderList[teamId] = (_teamsLookup_teamId = teamsLookup[teamId]) !== null && _teamsLookup_teamId !== void 0 ? _teamsLookup_teamId : team;
            }
        });
    };
    tasks.forEach(checkTask);
    return placeholderList;
};
export const getPlaceholdersFromTemplates = ({ templates, rolesWithPlaceholder, teamsLookup })=>{
    /**
   * list is maintained using name as key
   * since two different placeholders from different templates can have the same name,
   * and they need to be referred as a single placeholder in the form
   * but when making project API call, if the placeholder is assigned to an user,
   * it should be sent as two different teams, for which the duplicates key is used
   * which maintains the unqiue list of placeholders from other templates
   * having the same placeholder name.
   */ const placeholderList = {};
    const activeRoleIds = rolesWithPlaceholder === null || rolesWithPlaceholder === void 0 ? void 0 : rolesWithPlaceholder.map(({ roleId })=>roleId);
    const checkTask = (task)=>{
        var _assignee_teams;
        const { assignee, subTasks, private: isPrivate } = task;
        assignee === null || assignee === void 0 ? void 0 : (_assignee_teams = assignee.teams) === null || _assignee_teams === void 0 ? void 0 : _assignee_teams.forEach((team)=>{
            var _teamsLookup_teamId, _current_privateTaskCount;
            const { roleId, teamType, teamId } = team;
            if (teamType !== MemberType.External && (!roleId || !(activeRoleIds === null || activeRoleIds === void 0 ? void 0 : activeRoleIds.includes(roleId)))) {
                return;
            }
            /**
       * Picking the team object from store since team object inside template
       * may be outdated when the default placeholder name got changed
       * due to change in role name.
       */ const _team = (_teamsLookup_teamId = teamsLookup[teamId]) !== null && _teamsLookup_teamId !== void 0 ? _teamsLookup_teamId : team;
            const _current = placeholderList[_team.teamName];
            placeholderList[_team.teamName] = !(_current === null || _current === void 0 ? void 0 : _current.taskCount) ? {
                ..._team,
                taskCount: 1,
                privateTaskCount: isPrivate ? 1 : 0
            } : {
                ..._current,
                taskCount: _current.taskCount + 1,
                privateTaskCount: isPrivate ? ((_current_privateTaskCount = _current.privateTaskCount) !== null && _current_privateTaskCount !== void 0 ? _current_privateTaskCount : 0) + 1 : _current.privateTaskCount,
                ..._current.teamId !== team.teamId && {
                    duplicates: {
                        ..._current.duplicates,
                        [team.teamId]: _team
                    }
                }
            };
        });
        subTasks.forEach(checkTask);
    };
    const checkPhases = (phase)=>{
        const { assignees } = phase;
        if (assignees == null || assignees.length === 0) {
            return;
        }
        assignees.forEach((assignee)=>{
            var _assignee_team;
            if (((_assignee_team = assignee.team) === null || _assignee_team === void 0 ? void 0 : _assignee_team.teamId) == null || teamsLookup[assignee.team.teamId] == null) {
                return;
            }
            const _team = teamsLookup[assignee.team.teamId];
            const _current = placeholderList[_team.teamName];
            placeholderList[_team.teamName] = !(_current === null || _current === void 0 ? void 0 : _current.taskCount) ? {
                ..._team,
                taskCount: 0,
                privateTaskCount: 0
            } : {
                ..._current,
                ..._current.teamId !== _team.teamId ? {
                    duplicates: {
                        ..._current.duplicates,
                        [_team.teamId]: _team
                    }
                } : {}
            };
        });
    };
    templates.forEach(({ templateContent: { projectPhases, allocatedMembers, allocations }, effortPlanning })=>{
        projectPhases.forEach((phase)=>{
            const { tasks } = phase;
            tasks.forEach(checkTask);
            if (effortPlanning === EffortPlanningConfig.Phase) {
                checkPhases(phase);
            }
        });
        const totalAllocatedMinutes = getTotalAllocatedMinutesForTeamInTemplate(allocations !== null && allocations !== void 0 ? allocations : []);
        allocatedMembers === null || allocatedMembers === void 0 ? void 0 : allocatedMembers.teams.forEach((team)=>{
            var _teamsLookup_currentTeamId, _exisiting_totalAllocations;
            const { teamId: currentTeamId } = team;
            const _team = (_teamsLookup_currentTeamId = teamsLookup[currentTeamId]) !== null && _teamsLookup_currentTeamId !== void 0 ? _teamsLookup_currentTeamId : team;
            const exisiting = placeholderList[_team.teamName];
            placeholderList[_team.teamName] = !exisiting ? {
                ..._team,
                taskCount: 0,
                totalAllocations: totalAllocatedMinutes(currentTeamId)
            } : {
                ...exisiting,
                totalAllocations: ((_exisiting_totalAllocations = exisiting.totalAllocations) !== null && _exisiting_totalAllocations !== void 0 ? _exisiting_totalAllocations : 0) + totalAllocatedMinutes(currentTeamId),
                ...exisiting.teamId !== currentTeamId && {
                    duplicates: {
                        ...exisiting.duplicates,
                        [currentTeamId]: _team
                    }
                }
            };
        });
    });
    const [internalPlaceholders, externalPlaceholders] = Object.values(placeholderList).reduce((prev, _placeholder)=>{
        if (_placeholder.teamType === 'EXTERNAL') {
            return [
                prev[0],
                [
                    ...prev[1],
                    _placeholder
                ]
            ];
        }
        return [
            [
                ...prev[0],
                _placeholder
            ],
            prev[1]
        ];
    }, [
        [],
        []
    ]);
    return [
        internalPlaceholders,
        externalPlaceholders
    ];
};
export const getTranslationKeyForTeamHint = ({ taskCount = 0, totalAllocations = 0 })=>{
    if (taskCount > 0 && totalAllocations > 0) {
        return 'with_tasks_and_allocated_hours';
    }
    if (totalAllocations > 0) {
        return 'with_allocated_hours_only';
    }
    if (taskCount > 0) {
        return 'with_task_only';
    }
    return null;
};
